import React from 'react';
import PropTypes from 'prop-types';
import {
    Page,
    Text,
    View,
    StyleSheet,
} from "@react-pdf/renderer";
import moment from "moment-timezone";
import t from "../../../languages/pl";

const defaultClasses = StyleSheet.create({
    cellWidth: {
        width: "30%",
        margin: "auto"
    }
});

const IncidentsTable = props => {
    const { classes = defaultClasses, incidents, title } = props;

    const drawTable = data => {
        let i = 0;
        return data.map(row => {
            return (
                <View
                    key={i++}
                    style={classes.row}
                    break={i%20 === 0}
                >
                    <View style={[classes.cell, defaultClasses.cellWidth]}>
                        <Text style={classes.textPrimary}>
                            {moment.unix(row.data).format("DD/MM/YYYY \n HH:mm:ss")}
                        </Text>
                    </View>
                    <View style={[classes.cell, defaultClasses.cellWidth]} wrap>
                        <Text style={classes.textPrimary}>
                            {row.zdarzenie}
                        </Text>
                    </View>
                </View>
            );
        });
    };

    return (
        <Page
            style={classes.page}
            orientation="portrait"
        >
            <View style={classes.title}>
                <Text style={classes.textHeader}>
                    {title}
                </Text>
            </View>
            <View style={classes.table}>
                <View style={[classes.row, classes.headerCell]}>
                    <View style={[classes.cell, defaultClasses.cellWidth, classes.headerCell]}>
                        <Text style={classes.textPrimary}>
                            {t.date}:
                        </Text>
                    </View>
                    <View style={[classes.cell, defaultClasses.cellWidth, classes.headerCell]}>
                        <Text style={classes.textPrimary}>
                            {t.incident}:
                        </Text>
                    </View>
                </View>
            <View>
                {drawTable(incidents)}
            </View>
            </View>
        </Page>
    );
};

IncidentsTable.propTypes = {
    classes: PropTypes.object,
    incidents: PropTypes.array,
    title: PropTypes.string
};

export default IncidentsTable;
